import intl from "utils/intl";

import messages from "./messages";

export const localizeFuelingProcessStateName = (
  fuelingProcessState: string
): string =>
  fuelingProcessState in messages
    ? intl.formatMessage(messages[fuelingProcessState as keyof typeof messages])
    : fuelingProcessState;
